import {analysisAreaTypes, analysisCategories, AnalysisFull} from '@domain/rcfa'
import {StoppageSection, StoppageContent} from '@domain/stoppages'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../localization'
import {formatDate} from '../../../utils'
import {DeletedStoppageWarning} from '../../common/DeletedStoppageWarning'

type RootNodeDetailsProps = {
  analysisData: AnalysisFull
  dueDate?: string | null
}

export const RootNodeDetails = ({analysisData, dueDate}: RootNodeDetailsProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const stoppage = analysisData.stoppage
  const isDeleted = stoppage?.isDeleted
  return (
    <Stack spacing={2} pt={isDeleted ? 0 : 2} mb={2}>
      {isDeleted && <DeletedStoppageWarning />}
      <StoppageSection
        label={t('label.analysisCategoryLabel')}
        value={analysisCategories.find((category) => category.id === analysisData.category)?.label}
      />
      <StoppageSection
        label={t('label.searchAnalysisAreaTypeLabel')}
        value={analysisAreaTypes.find((t) => t.id === analysisData.areaTypeCode)?.label}
      />
      {stoppage?.stoppageCode && (
        <>
          {/* ASSET & CODE */}
          <StoppageContent stoppage={stoppage} translationNamespace={FEATURE_NAMESPACE} />

          <StoppageSection
            label={t('tables.tasksList.dueDate')}
            value={dueDate ? formatDate(dueDate) : '-'}
          />
          <Stack direction="row" spacing={4}>
            <StoppageSection
              label={t('stoppage.detail.equipment')}
              value={analysisData?.equipmentName}
            />
            <StoppageSection
              label={t('stoppage.detail.equipmentId')}
              value={stoppage?.equipment?.text}
              labelBottom={stoppage?.equipment?.id}
            />
          </Stack>
        </>
      )}
    </Stack>
  )
}
